import { isString } from '@/utils/checkers/validation'

export const humanize = (
  value: string,
  overwrite?: string | unknown[],
  upperFirstOnly?: boolean,
): string => {
  if (typeof overwrite === 'string' && overwrite.length > 0) {
    return overwrite
  }
  if (!isString(value)) {
    return ''
  }
  const humanized = value
    .toString()
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .toLowerCase()
    .replace(/[_-]/g, ' ')
    .replace(/(?:^|\s)\S/g, function (a: string, index: number) {
      return index === 0 || !upperFirstOnly ? a.toUpperCase() : a
    })

  return humanized
}

/**
 * @method truncate
 * @param  {Number} letters max letters numbers
 * @param  {String} word    word to analyze
 * @return {String} truncated word
 */
export const truncate = (letters: number, word: string): string => {
  if (word?.length > letters) {
    return word.slice(0, letters) + '...'
  }

  return word
}

export const capitalizeSingleWord = (text?: string): string =>
  text ? text.charAt(0).toUpperCase() + text.slice(1) : ''

/**
 * @description capitalize the first letter of every words of a string passed as argument
 * @method capitalize
 * @param  {string} text
 * @return {string}
 */
export const capitalize = (text: string | undefined): string => {
  if (text === '' || text === undefined) {
    return ''
  }
  const words = text.split(' ')
  const capitalizedWords = words.map((word) => capitalizeSingleWord(word))
  return capitalizedWords.join(' ')
}

/**
 * @description unescape HTML information to prevent security issues
 * @method stripHtml
 * @param  {string} value
 * @return {string}
 */
export const stripHtml = (value: string): string => {
  const doc = new DOMParser().parseFromString(value, 'text/html')
  if (!doc.body) {
    return ''
  }
  return doc.body.textContent || ''
}

/**
 * @function toLowerCase
 * @param {any} value
 * @returns {String}
 */
export const toLowerCase = (value: string): string => `${value}`.toLowerCase()
